goog.provide('el8.practicedata.labVendorIntegrations');

goog.require('el8.model.base');
goog.require('el8.service.urls');
goog.require('el8.util.string');

/**
 * This represents LabVendorIntegration in the backend
 */
el8.practicedata.labVendorIntegrations = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDeleteable();

    _class.addIntProperty('labVendorId', true);
    _class.addBoolean('ordersIntegrationIsLive', true);


    _class.prototype.populate = function(spec) {
        spec = spec || {};
        // we expect a lab_vendor, or labVendorID
        if (spec.lab_vendor) {
            el8.data.labVendors.create(spec.lab_vendor);
            spec.labVendorId = spec.lab_vendor.id;
            spec.ordersIntegrationIsLive = spec.orders_integration_is_live;
        }
        this.parent.populate.call(this, spec);
    };

    _class.prototype.asSoyMap = function() {
        var m = {};
        m['id'] = this.getId();
        m['labVendorId'] = this.getLabVendorId();
        m['labVendor'] = el8.data.labVendors.getById(this.getLabVendorId()).asSoyMap();
        m['ordersIntegrationIsLive'] = this.isOrdersIntegrationIsLive();
        return m;
    };

    _class.prototype.getLabVendor = function() {
        return el8.data.labVendors.getById(this.getLabVendorId());
    };

    var that =  new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        sortFn: function(a, b) {
            return el8.util.string.cmp(a.getLabVendor().getDisplayName(), b.getLabVendor().getDisplayName());
        },
        urlLoad: function() { return el8.service.urls.get('labVendorIntegrations'); },
        urlFn: function(id) { return el8.service.urls.get('labVendorIntegrations', [id]); },
        saveFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('labVendorIntegrations', [item.getId()]),
                data: item.asMap(true),
                success: function(data) {
                    item.populate(data);
                    successCb(data);
                },
                error: errorCb
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('labVendorIntegrations', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        }
    });

    that.sortedWithoutOrdersLive = function() {
        return this.sorted().filter(function(integration) {
            return !integration.isOrdersIntegrationIsLive();
        }).map(function(integration) {
            return integration.getLabVendor().asSoyMap();
        });
    };

    return that;
})();
